import { api } from '@/lib/api'
import { ApiHttpError } from '@/api/auth'

export interface AgentInvitationPreview {
  id: number
  email: string
  company_name: string
  manager_name: string
  expires_at: string
  is_expired: boolean
}

export interface AcceptInvitationInput {
  token: string
  first_name: string
  last_name: string
  phone_number?: string
  password: string
  confirm_password: string
}

export interface AcceptInvitationResponse {
  message: string
  user_id: number
  email: string
  company_id: number
  company_name: string
  tokens: {
    access_token: string
    refresh_token: string
  }
}

/** GET /api/agents/setup/<token>/ — endpoint public, sans JWT. */
export async function fetchAgentInvitation(token: string): Promise<AgentInvitationPreview> {
  const res = await fetch(`${api.defaults.baseURL}/api/agents/setup/${encodeURIComponent(token)}/`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new ApiHttpError(res.status, data)
  return data as AgentInvitationPreview
}

/** POST /api/agents/setup/ — endpoint public, retourne les tokens JWT. */
export async function acceptAgentInvitation(input: AcceptInvitationInput): Promise<AcceptInvitationResponse> {
  const res = await fetch(`${api.defaults.baseURL}/api/agents/setup/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(input),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new ApiHttpError(res.status, data)
  return data as AcceptInvitationResponse
}


/** Cellulaire de l'invité, vérifié AVANT la création du compte : le jeton d'invitation tient lieu d'identité. */
export async function sendInvitationPhoneCode(token: string, phone: string, lang: string): Promise<void> {
  const res = await fetch(`${api.defaults.baseURL}/api/agents/setup/phone/send-code/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ token, phone, lang }),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new ApiHttpError(res.status, data)
}

export async function verifyInvitationPhoneCode(token: string, code: string): Promise<void> {
  const res = await fetch(`${api.defaults.baseURL}/api/agents/setup/phone/verify-code/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ token, code }),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new ApiHttpError(res.status, data)
}
